export default __webpack_public_path__ + "static/media/img_16.35d16de1.jpg";